export default "__VITE_PUBLIC_ASSET__b37d181f__"